export const translations = {
  // Page meta - Enhanced for 2026 SEO
  pageTitle: {
    en: 'Hong Kong Bank Code Lookup 2026 - 127 Banks Complete Directory | HKMA Licensed',
    zh: '香港銀行代碼查詢 2026 - 127間銀行完整目錄 | 金管局認可'
  },
  pageDescription: {
    en: 'Official Hong Kong bank clearing code directory with 127 HKMA-licensed banks including 8 virtual banks (ZA Bank, Livi Bank, MOX Bank). Instant bilingual search, smart filtering, mobile-optimized. Updated March 2026.',
    zh: '香港官方銀行結算代碼目錄，涵蓋127間金管局認可銀行，包括8間虛擬銀行（ZA Bank、Livi Bank、MOX Bank）。即時雙語搜尋、智能篩選、手機優化。2026年3月更新。'
  },

  // Header - SEO optimized
  title: {
    en: 'Hong Kong Bank Code Lookup',
    zh: '香港銀行代碼查詢'
  },
  subtitle: {
    en: '127 HKMA Licensed Banks | Updated March 2026',
    zh: '127間金管局認可銀行 | 2026年3月更新'
  },

  // Search - Optimized for clarity
  searchLabel: {
    en: 'Search Banks',
    zh: '搜尋銀行'
  },
  searchPlaceholder: {
    en: 'Search by code, name (e.g., HSBC, 004)...',
    zh: '搜尋代碼或名稱（例如：滙豐、004）...'
  },
  clearSearch: {
    en: 'Clear search',
    zh: '清除搜尋'
  },
  searching: {
    en: 'Searching 127 banks...',
    zh: '搜尋127間銀行中...'
  },

  // Sort
  sortBy: {
    en: 'Sort by',
    zh: '排序方式'
  },
  sortByCode: {
    en: 'Code',
    zh: '代碼'
  },
  sortByName: {
    en: 'Name',
    zh: '名稱'
  },
  sortStatus: {
    en: {
      code: {
        asc: 'Sorted by Code Ascending',
        desc: 'Sorted by Code Descending'
      },
      name: {
        asc: 'Sorted by Name Ascending',
        desc: 'Sorted by Name Descending'
      }
    },
    zh: {
      code: {
        asc: '按代碼升序排列',
        desc: '按代碼降序排列'
      },
      name: {
        asc: '按名稱升序排列',
        desc: '按名稱降序排列'
      }
    }
  },

  // Quick Navigation
  quickNavTitle: {
    en: 'Quick Navigation by Code Range',
    zh: '按代碼範圍快速導航'
  },
  quickNavSubtitle: {
    en: 'Filter 127 banks by clearing code ranges',
    zh: '按結算代碼範圍篩選127間銀行'
  },
  quickNavAll: {
    en: 'All Banks',
    zh: '全部銀行'
  },

  // Table headers
  thCode: {
    en: 'Bank Code',
    zh: '銀行代碼'
  },
  thNameEn: {
    en: 'English Name',
    zh: '英文名稱'
  },
  thNameZh: {
    en: 'Chinese Name',
    zh: '中文名稱'
  },

  // Results
  resultsTitle: {
    en: 'Search Results',
    zh: '搜尋結果'
  },
  resultsCount: {
    en: 'Showing {count} of {total} banks',
    zh: '顯示 {count} / {total} 間銀行'
  },
  resultsCountLabel: {
    en: 'banks',
    zh: '間銀行'
  },
  resultsCountSingle: {
    en: 'Showing 1 bank',
    zh: '顯示 1 間銀行'
  },
  loading: {
    en: 'Loading 127 banks...',
    zh: '載入127間銀行資料中...'
  },

  // No results
  noResults: {
    title: {
      en: 'No Banks Found',
      zh: '沒有找到銀行'
    },
    message: {
      en: 'Try searching for HSBC (004), Hang Seng (024), or adjust your filters',
      zh: '嘗試搜尋滙豐（004）、恒生（024），或調整篩選條件'
    }
  },

  // Pagination
  pagination: {
    previous: {
      en: 'Previous',
      zh: '上一頁'
    },
    next: {
      en: 'Next',
      zh: '下一頁'
    },
    page: {
      en: 'Page {current} of {total}',
      zh: '第 {current} 頁，共 {total} 頁'
    },
    itemsPerPage: {
      en: 'Items per page',
      zh: '每頁顯示'
    }
  },

  // About section - Enhanced for AI search
  aboutTitle: {
    en: 'About Hong Kong Bank Code Directory',
    zh: '關於香港銀行代碼目錄'
  },
  aboutDescription: {
    en: 'This comprehensive directory provides instant access to all 127 HKMA-licensed Hong Kong bank clearing codes and institution information. Our database includes all major banks (HSBC, Hang Seng, Standard Chartered, Bank of China HK) and 8 virtual banks (ZA Bank, Livi Bank, MOX Bank, WeLab Bank, Fusion Bank, PingAn OneConnect, Ant Bank, Airstar Bank), making it an essential tool for financial professionals, businesses, developers, and individuals conducting banking transactions.',
    zh: '本綜合目錄提供即時查詢所有127間香港金管局認可銀行的結算代碼和機構資訊。我們的資料庫包含所有主要銀行（滙豐、恒生、渣打、中銀香港）和8間虛擬銀行（ZA Bank、Livi Bank、MOX Bank、WeLab Bank、Fusion Bank、平安壹賬通、螞蟻銀行、天星銀行），是金融專業人士、企業、開發者和個人進行銀行交易的必備工具。'
  },
  aboutFeatures: {
    en: 'Key Features',
    zh: '主要功能'
  },
  feature1: {
    en: 'Real-time search across 127 HKMA-licensed banks',
    zh: '即時搜尋127間金管局認可銀行'
  },
  feature2: {
    en: 'Bilingual interface (English & Traditional Chinese)',
    zh: '雙語界面（英文及繁體中文）'
  },
  feature3: {
    en: 'Mobile-optimized responsive design for all devices',
    zh: '全裝置優化的響應式設計'
  },
  feature4: {
    en: 'Smart filtering by code ranges and dark theme support',
    zh: '智能範圍篩選及深色主題支援'
  },
  dataSource: {
    en: 'Data Source: Hong Kong Monetary Authority (HKMA) via Hong Kong Interbank Clearing Ltd. Last updated: November 6, 2024. This directory includes all HKMA-licensed banks and deposit-taking institutions.',
    zh: '資料來源：香港金融管理局（金管局）經香港銀行同業結算有限公司。最後更新：2024年11月6日。本目錄包含所有金管局認可銀行及接受存款機構。'
  },

  // Footer - Updated to 2026
  footerCopyright: {
    en: '2026 Hong Kong Bank Code Directory',
    zh: '2026 香港銀行代碼目錄'
  },
  footerMadeBy: {
    en: 'Developed with',
    zh: '開發：'
  },
  footerCompany: {
    en: 'Homy Tech Limited',
    zh: 'Homy Tech Limited'
  },
  footerCompanyUrl: {
    en: 'https://homy.hk',
    zh: 'https://homy.hk'
  }
}